/**
 * Created by markus on 08.12.16.
 */
$(document).ready(function () {

    // Slider allgemein
    $('.slider.basic').each(function (i,e) {

        var $basicSlider = $(e),
            $item = $basicSlider.find('.csc-default'),
            prevText = $item.data('prev-text'),
            nextText = $item.data('next-text');

        $basicSlider.slick({
            dots: true,
            infinite: true,
            mobileFirst: true,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="' + prevText + '">' + prevText + '</button>',
            nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="' + nextText + '">' + nextText + '</button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        infinite: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        // Ändere Attribute des Sliders
        changeSlideAttributes($basicSlider);

        //Setze Attribute neu
        if($basicSlider.find('.slick-dots li').length) {

            // Ändere Attribute der Punkte
            changeDotAttributes($basicSlider, $basicSlider.find('.slick-dots'));
        }
    });


    // Slider Events Startseite
    $('.slider.events').each(function (i,e) {
        var $eventSlider = $(e),
            $item = $eventSlider.find('.csc-default'),
            prevText = $item.data('prev-text'),
            nextText = $item.data('next-text');

        $eventSlider.slick({

            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="' + prevText + '">' + prevText + '</button>',
            nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="' + nextText + '">' + nextText + '</button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        infinite: false,
                        dots: false
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: true
                    }
                },
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true
                    }
                }
            ]
        });

        // Ändere Attribute des Sliders
        changeSlideAttributes($eventSlider);

        //Setze Attribute neu
        if($eventSlider.find('.slick-dots li').length) {

            // Ändere Attribute der Punkte
            changeDotAttributes($eventSlider, $eventSlider.find('.slick-dots'));
        }

        $(window).on('resize', debouncer(function(){

            // Ändere Attribute des Sliders
            changeSlideAttributes($eventSlider);

            //Setze Attribute neu
            if($eventSlider.find('.slick-dots li').length) {

                // Ändere Attribute der Punkte
                changeDotAttributes($eventSlider, $eventSlider.find('.slick-dots'));
            }
        }));
    });


    // Slider Rundgang Detailseite Ausstellung
    $('.slider.tour').each(function (i,e) {
        var $tourSlider = $(e),
            $item = $tourSlider.find('.csc-default'),
            prevText = $item.data('prev-text'),
            nextText = $item.data('next-text');

        $tourSlider.slick({

            dots: true,
            infinite: true,
            mobileFirst: true,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 1,
            prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="' + prevText + '">' + prevText + '</button>',
            nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="' + nextText + '">' + nextText + '</button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: true
                    }
                },
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true
                    }
                }
            ]
        });

        // Ändere Attribute des Sliders
        changeSlideAttributes($tourSlider);

        //Setze Attribute neu
        if($tourSlider.find('.slick-dots li').length) {

            // Ändere Attribute der Punkte
            changeDotAttributes($tourSlider, $tourSlider.find('.slick-dots'));
        }
    });


    // Slider Rundgang Detailseite Kindermuseum mit Thumbnails
    $('.slider-for').each(function (i,e) {
        var $forSlider = $(e),
            $navSlider = $forSlider.next('.slider-nav'),
            $item = $forSlider.find('.csc-default'),
            prevText = $item.data('prev-text'),
            nextText = $item.data('next-text');

        $forSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="' + prevText + '">' + prevText + '</button>',
            nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="' + nextText + '">' + nextText + '</button>',
            fade: true,
            asNavFor: $navSlider[0]
        });

        $navSlider.slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            asNavFor: $forSlider[0],
            dots: true,
            arrows: false,
            centerMode: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 1,
                        infinite: true,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });


        // Ändere Attribute des Sliders
        changeSlideAttributes($forSlider);

        //Setze Attribute neu
        if($navSlider.find('.slick-dots li').length) {

            // Ändere Attribute der Punkte
            changeDotAttributes($forSlider, $navSlider.find('.slick-dots'));

            // hole ID von .slick-dots
            var dotCountStartTemp = $navSlider.find('.slick-dots li:first button').attr('id').match(/\d/g),
                dotCountStart = parseInt(dotCountStartTemp.join(""));

            $forSlider.find('.slick-slide').each(function (i, e) {
                var $slide = $(e),
                    aria = $slide.attr('aria-describedby'),
                    currentCount = dotCountStart + i;

                if(currentCount <= 9) {
                    currentCount = '0' + currentCount;
                }

                // Setze Attribute ID und aria-describedby neu mit Zahl aus .slick-dots ermittelt
                $slide
                    .attr({
                        'id': 'navigation' + currentCount,
                        'aria-describedby': 'slick-slide' + currentCount
                    });
            });
        }

    });

    // Slider Zitat
    $('.slider.blockquote').each(function (i,e) {
        var $blockquoteSlider = $(e),
            $item = $blockquoteSlider.find('.csc-default'),
            prevText = $item.data('prev-text'),
            nextText = $item.data('next-text');

        $blockquoteSlider.slick({

            dots: true,
            infinite: true,
            mobileFirst: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="' + prevText + '">' + prevText + '</button>',
            nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="' + nextText + '">' + nextText + '</button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        // Ändere Attribute des Sliders
        changeSlideAttributes($blockquoteSlider);

        //Setze Attribute neu
        if($blockquoteSlider.find('.slick-dots li').length) {

            // Ändere Attribute der Punkte
            changeDotAttributes($blockquoteSlider, $blockquoteSlider.find('.slick-dots'));
        }
    });


});




// Ändert die Attribute des Sliders
function changeSlideAttributes($slider) {
    // Ändere falsche Attribute
    var $slickTrack = $slider.find('.slick-track'),
        $slickSlide = $slickTrack.find('.slick-slide');

    // Ändere falsches Attribut role
    $slickTrack.attr('role','list');

    $slickSlide.each(function (i, e) {
        var $slide = $(e);

        // ... und ändere falsches Attribut role
        $slide.attr('role','listitem');

    });
}

// Ändert die Attribute der Slider Punkte
function changeDotAttributes($slider, $dots) {
    const $target = $slider.find('[aria-live="polite"]'),
        // $navSlider = $slider.next('.slider-nav'),
        // $dots = $navSlider.find('.slick-dots'),
        id = $slider.attr('id'),
        prefixedId = 'slick-list-' + id,
        $item = $slider.find('.csc-default'),
        dotsText = $item.data('dots-text');

    // Eine einzigarte ID hinzufügen auf welche verwiesen werden kann
    $target.attr('id', prefixedId);

    // Verweise auf einzigartige ID und entferne falsche Attribute
    $dots.attr('aria-controls', prefixedId).removeAttr('role');

    // Durchlaufe alle Slickslider Navigations-Punkte ...
    $dots.find('li').each(function (i, e) {
        var $dot = $(e);

        // ... und entferne falsche Attribute
        $dot.removeAttr('role').removeAttr('aria-hidden').removeAttr('aria-controls');
    });

    $dots.find('button').each(function (i, e) {
        var $button = $(e);

        // ... setze Text vor Button-Text
        textDefault = $button.text();
        $button.text(dotsText + textDefault);
    });
}

